import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import Clock from 'react-clock';
import moment from 'moment';
import "./App.css"
import Main from './Main'
import Typed from 'react-typed';
import 'react-clock/dist/Clock.css';
//firebase
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database"

import firebaseConfig from "./Config/firebaseConfig";
//init firebase
firebase.initializeApp(firebaseConfig);


function App() {
  const [value, setValue] = useState(new Date());
  let today = moment().format("DD-MMM-YY");
  useEffect(() => {
    const interval = setInterval(
      () => setValue(new Date()),
      1000
    );

    return () => {
      clearInterval(interval);
    }
  }, []);

  return (
    <>
      <Main active="home">
        <section id="hero" className="d-flex flex-column justify-content-center align-items-center" style={{ "position": "relative" }}>
          <div className="hero-container">
            <h5 style={{ "color": "white" }}>Hi, Welcome to my portfolio! My name is</h5>
            <h1>Barun Kumar Pandey</h1>
            <span className="desc p-r-10">I'm</span>
            <Typed className="desc-details"
              strings={['Experienced Software Engineer', 'Designer', "Developer", 'Trainer']}
              typeSpeed={120}
              backSpeed={80}
              loop
            />
            <div style={{ "position": "relative", "top": "30px", "textAlign": "center" }}>
              <Link className="btn btn-primary" to="/about"><i className="bx bx-user"></i>&nbsp;About Me</Link>
            </div>
          </div>
          <div className="react-clock-div">
            <Clock value={value} />
          </div>
          <h4 className="date-div">{today}</h4>
        </section>
      </Main>
    </>
  )
}

export default App
